import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const LogoffIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M23.6696 12.8348C24.1101 12.3732 24.1101 11.6268 23.6696 11.1701L17.6701 4.87946C17.2296 4.41786 16.5171 4.41786 16.0812 4.87946C15.6453 5.34107 15.6407 6.0875 16.0812 6.5442L20.159 10.8165L8.62416 10.8214C8.00078 10.8214 7.49927 11.3469 7.49927 12C7.49927 12.6531 8.00078 13.1786 8.62416 13.1786H20.159L16.0812 17.4509C15.6407 17.9125 15.6407 18.6589 16.0812 19.1156C16.5218 19.5723 17.2343 19.5772 17.6701 19.1156L23.6696 12.8348ZM7.87423 3.35714C8.49761 3.35714 8.99912 2.8317 8.99912 2.17857C8.99912 1.52545 8.49761 1 7.87423 1H4.1246C1.84669 1 0 2.93482 0 5.32143V18.6786C0 21.0652 1.84669 23 4.1246 23H7.87423C8.49761 23 8.99912 22.4746 8.99912 21.8214C8.99912 21.1683 8.49761 20.6429 7.87423 20.6429H4.1246C3.08876 20.6429 2.24978 19.7638 2.24978 18.6786V5.32143C2.24978 4.23616 3.08876 3.35714 4.1246 3.35714H7.87423Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default LogoffIcon
